var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXdefi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4A74E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3578 14.2153C13.5475 14.9903 11.6638 16.3953 8.53868 16.5869C5.04026 16.7998 3.5821 15.548 3.56857 15.5352L3.28622 15.9184L3.5705 15.5416L3 16.2952C3.06188 16.3527 4.46009 17.596 7.74384 17.596C8.01265 17.596 8.295 17.596 8.58895 17.5704C12.3658 17.3383 14.4409 15.5246 15.1642 14.7497L14.3578 14.2153Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8741 15.2287C15.3949 15.922 14.8052 16.5136 14.1336 16.9744C11.7666 18.6561 8.75545 18.8732 6.6475 18.7562L6.60303 19.7376C6.95693 19.7567 7.2973 19.7653 7.62799 19.7653C13.5728 19.7653 15.9747 16.7849 16.6457 15.7205L15.8722 15.2202",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6477 11.5138C16.0418 11.5138 16.3613 11.1621 16.3613 10.7283C16.3613 10.2945 16.0418 9.94275 15.6477 9.94275C15.2536 9.94275 14.9341 10.2945 14.9341 10.7283C14.9341 11.1621 15.2536 11.5138 15.6477 11.5138Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5541 13.1041C13.3087 13.9556 11.6417 14.3942 9.95339 14.3005C8.53391 14.2239 7.36971 13.6619 6.66577 12.738C6.04692 11.9119 5.80712 10.822 5.96957 9.56811C6.02463 9.1514 6.13746 8.74646 6.30413 8.36744L6.32734 8.31422C6.91164 7.07589 7.77879 6.02639 8.84344 5.269C9.90808 4.51159 11.1335 4.07241 12.3992 3.99466C13.6648 3.9169 14.9271 4.20327 16.0617 4.82556C17.1962 5.44786 18.1641 6.38464 18.8699 7.5437C19.5758 8.70277 19.9953 10.0442 20.0872 11.4359C20.1791 12.8276 19.9402 14.2217 19.3941 15.481C18.8479 16.7403 18.0133 17.8212 16.9724 18.6176C15.9315 19.414 14.7201 19.8983 13.4576 20.0229L13.535 21C14.9525 20.861 16.3127 20.3179 17.4815 19.4241C18.6504 18.5305 19.5876 17.317 20.2008 15.9032C20.8139 14.4894 21.082 12.9242 20.9785 11.3618C20.8749 9.79931 20.4034 8.29349 19.6103 6.99266C18.8173 5.69182 17.7301 4.64085 16.4558 3.94329C15.1816 3.24572 13.7641 2.92563 12.3433 3.01454C10.9224 3.10344 9.5471 3.59829 8.35283 4.45032C7.15856 5.30234 6.18654 6.48217 5.53251 7.87355L5.50157 7.9438C5.29481 8.41414 5.15522 8.91678 5.08771 9.43399C4.89432 10.9625 5.19408 12.3228 5.9773 13.3702C6.83402 14.5155 8.22836 15.1967 9.90118 15.2862C11.9376 15.399 13.9623 14.788 15.3992 13.664L14.5541 13.1041Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdefi);
export default __webpack_public_path__ + "static/media/xdefi.22e162848dec5a044ae93e8e37098d92.svg";
export { ForwardRef as ReactComponent };